/**
 * One-time move of local data saved under the game's former name (`warband:*`) to the
 * `seven-dawns:*` keys, so renaming the game keeps players' seats, profile and settings.
 * Imported first in main.tsx: stores read localStorage when their modules load.
 */
const OLD_PREFIX = 'warband:';
const NEW_PREFIX = 'seven-dawns:';

export function migrateLegacyStorage(storage: Storage): void {
  const oldKeys: string[] = [];
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (key?.startsWith(OLD_PREFIX)) oldKeys.push(key);
  }
  for (const key of oldKeys) {
    const newKey = NEW_PREFIX + key.slice(OLD_PREFIX.length);
    const value = storage.getItem(key);
    if (value !== null && storage.getItem(newKey) === null) storage.setItem(newKey, value);
    storage.removeItem(key);
  }
}

try {
  migrateLegacyStorage(localStorage);
} catch {
  // Storage blocked (private mode): nothing to migrate.
}
